import EmbeddedVideo from 'components/features-page/EmbeddedVideo'
import { ReactElement } from 'react'

export default function FeatureVideo({ osType }: { osType: string }): ReactElement {
  if (osType === 'linux') {
    return <></>
  }

  return (
    <EmbeddedVideo
      videoSrc={
        osType === 'windows'
          ? 'https://www.youtube.com/embed/IrFnvNVdqF4'
          : 'https://www.youtube.com/embed/djyBRjPgqVA'
      }
    />
  )
}
